<template>

<core-panel v-if="is.ready">

	<template v-slot:head>

		Comment

	</template>

	<template v-slot:body>

		<div class="comment-head" :style="{backgroundImage: gameAvatar}"></div>

		<div class="comment-user">

			<core-avatar type="user" :id="data.play.user" class="comment-user-avatar" />

			<div class="comment-user-name">

				<div class="comment-user-name-big">{{ realname }}</div>
				<div class="comment-user-name-small" v-if="realname !== username">{{ username }}</div>

			</div>

		</div>

		<p class="comment-text" v-html="comment"></p>

		<div class="comment-info">

			Played on {{ data.play.date | formatDate($util.date.format('Do', 'MMMM', 'YYYY')) }}

		</div>

	</template>

</core-panel>

</template>

<script>

import Panel from './../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			static: true,
			params: {
				game: false,
				play: false,
				comment: false
			}
		}

	},

	computed: {

		user: function() {

			return this.$store.getters['data/users/associated'][this.data.play.user]

		},

		realname: function() {

			return this.user.fullname || this.user.name

		},

		username: function() {

			return this.user.name

		},

		comment: function() {

			return this.data.comment

		},

		gameAvatar: function() {

			return 'url(' + this.$util.thumbnail.game.generate(this.data.game.id, 'large') + ')'

		}

	}

}

</script>

<style scoped>

.comment-text {
	font-size: 16px;
	color: #fff;
	line-height: 20px;
	padding: 0px 20px;
}

.comment-head {
	width: 100%;
	height: 160px;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-size: cover;
	flex-shrink: 0;
	margin-bottom: 20px;
}

.comment-user {
	display: flex;
	flex-direction: row;
	padding: 0px 20px 20px 20px;
}

.comment-user-avatar {
	width: 48px;
	height: 48px;
	border-radius: 24px;
	flex-shrink: 0;
	margin-right: 20px;
}

.comment-user-name {
	flex-grow: 1;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.comment-user-name-big {
	width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 500;
    color: #fff;
    display: block;
    margin-top: 0px;
    font-size: 20px;
    line-height: 24px;
}

.comment-user-name-small {
	font-size: 12px;
    font-weight: 400;
    color: #fff;
}

.comment-info {
	padding: 20px;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.75);
}

</style>